export default function(options, router){
  options = {
    url: '', //路由地址
    type: '', //权限类型  1 验证登录 ...
    source: '', //来源地址 权限验证成功之后的默认返回页面地址 为空时一般刷新当前页面
    back: true, //是否返回  默认true   可选值 true/false  source 不为空时生效
    ...options
  };
  
  let now = Date.now();
  let loginTime = localStorage.getItem('token_log_time');
  if (now-loginTime>30*60*1000||!loginTime) {
    // navto('replace', '/login');
    // return false;
  }
 
  
  //验证登录
  if (options.type===1){
    if (localStorage.getItem('user_token')) {
      navto('replace', '/info', {
        query:{
          shid:localStorage.getItem('shid')
        }
      });
    } else {
      navto('replace', '/login', {
        query:{
          shid:localStorage.getItem('shid')
        }
      });
    }
  }
  
  function navto(type, path, other) {
    if (router) {
      if (router.history.current.path!=path) {
        router[type]({
          path,
          ...other
        });
      }
    }
  }
}